export const surveyJson = {
    "locale": "zh-cn",
    "title": "中学生心理健康问卷",
    "description": "请同学们认真作答，以帮助学校更好的了解同学们的心理健康情况。",
    "logoPosition": "right",
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "text",
                    "name": "question1",
                    "title": {
                        "zh-cn": "姓名"
                    }
                },
                {
                    "type": "radiogroup",
                    "name": "question4",
                    "title": {
                        "zh-cn": "性别"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "男"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "女"
                            }
                        }
                    ]
                },
                {
                    "type": "dropdown",
                    "name": "question2",
                    "title": {
                        "zh-cn": "年级"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "小学三年级"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "小学四年级"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "小学五年级"
                            }
                        },
                        {
                            "value": "Item 4",
                            "text": {
                                "zh-cn": "小学六年级"
                            }
                        },
                        {
                            "value": "Item 5",
                            "text": {
                                "zh-cn": "初一"
                            }
                        },
                        {
                            "value": "Item 6",
                            "text": {
                                "zh-cn": "初二"
                            }
                        },
                        {
                            "value": "Item 7",
                            "text": {
                                "zh-cn": "初三"
                            }
                        },
                        {
                            "value": "Item 8",
                            "text": {
                                "zh-cn": "高一"
                            }
                        },
                        {
                            "value": "Item 9",
                            "text": {
                                "zh-cn": "高二"
                            }
                        },
                        {
                            "value": "Item 10",
                            "text": {
                                "zh-cn": "高三"
                            }
                        }
                    ]
                },
                {
                    "type": "dropdown",
                    "name": "question3",
                    "title": {
                        "zh-cn": "班级"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "1班"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "2班"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "3班"
                            }
                        },
                        {
                            "value": "Item 4",
                            "text": {
                                "zh-cn": "4班"
                            }
                        },
                        {
                            "value": "Item 5",
                            "text": {
                                "zh-cn": "5班"
                            }
                        },
                        {
                            "value": "Item 6",
                            "text": {
                                "zh-cn": "6班"
                            }
                        },
                        {
                            "value": "Item 7",
                            "text": {
                                "zh-cn": "7班"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question5",
                    "title": {
                        "zh-cn": "你是否为独生子女"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "否（三孩及以上家庭）"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "否（二孩家庭）"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "是"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question6",
                    "title": {
                        "zh-cn": "你是否住校"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "否"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "是"
                            }
                        },
                        "Item 3"
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question7",
                    "title": {
                        "zh-cn": "父母对你采取的主要教养方式是"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "常常让你服从他们，为你设定多个目标"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "常常听取你的想法，为你设定目标的同时保留你的自主权"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "常常满足你的愿望，很少提要求或限制你的行为"
                            }
                        },
                        {
                            "value": "Item 4",
                            "text": {
                                "zh-cn": "不太关心你的生活和学习，期待较少，更多提供物质支持，很少限制你的行为"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question8",
                    "title": {
                        "zh-cn": "你是否与父母一方或双方分开居住半年以上"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "否"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "是"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question9",
                    "title": {
                        "zh-cn": "“父母或其他长辈每天都会花一定的时间陪伴你学习”这个描述符合你的实际情况吗"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "很不符合"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "不太符合"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "比较符合"
                            }
                        },
                        {
                            "value": "Item 4",
                            "text": {
                                "zh-cn": "很符合"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question10",
                    "title": {
                        "zh-cn": "你家庭的经济状况如何"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "不好"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "一般"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "较好"
                            }
                        },
                        {
                            "value": "Item 4",
                            "text": {
                                "zh-cn": "好"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question11",
                    "title": {
                        "zh-cn": "你从学校拿回来的文件或通知，一般由谁签字"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "爸爸"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "妈妈"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "爷爷奶奶或外公外婆"
                            }
                        },
                        {
                            "value": "Item 4",
                            "text": {
                                "zh-cn": "兄弟姐妹"
                            }
                        },
                        {
                            "value": "Item 5",
                            "text": {
                                "zh-cn": "其他家人"
                            }
                        },
                        {
                            "value": "Item 6",
                            "text": {
                                "zh-cn": "没有人签字"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question12",
                    "title": {
                        "zh-cn": "请根据自己半年内的日常学习情况，选择最符合的一项"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "非常不同意"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "不同意"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "不确定"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "同意"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "非常同意"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "我很害怕成绩不好"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "作业太多让我感到压力很大"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "我被考试的压力压垮了"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "我厌倦了学习"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question13",
                    "title": {
                        "zh-cn": "请仔细阅读每道题目，根据自身实际情况选择相应的选项"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "很不符合"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "不符合"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "不确定"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "有点符合"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "完全符合"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "当事情发生变化时，我能够适应"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "不管我的人生路途中发生任何事情，我都能处理"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "当面对问题时，我试着去看事情积极的一面"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "由于经历过磨练，我变得更坚强了"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "在生病、受伤、苦难之后，我很容易能恢复过来"
                            }
                        },
                        {
                            "value": "Row 6",
                            "text": {
                                "zh-cn": "我相信即使遇到障碍我也能够实现我的目标"
                            }
                        },
                        {
                            "value": "Row 7",
                            "text": {
                                "zh-cn": "在压力下，我能够集中注意力并清晰思考"
                            }
                        },
                        {
                            "value": "Row 8",
                            "text": {
                                "zh-cn": "我不会因为失败而轻易气馁"
                            }
                        },
                        {
                            "value": "Row 9",
                            "text": {
                                "zh-cn": "我认为自己是个坚强有能力的人"
                            }
                        },
                        {
                            "value": "Row 10",
                            "text": {
                                "zh-cn": "我能够处理一些不愉快或痛苦的感受，例如悲伤、害怕和生气"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question14",
                    "title": {
                        "zh-cn": "以下列出的是当你在生活中经受到挫折或遇到困难时可能采取的态度和做法，请仔细阅读每一项，然后选择最合适的选项。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "不采取"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "偶尔采取"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "不确定"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "有时采取"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "经常采取"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "通过工作学习或一些其他活动解脱"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "与人交谈，倾诉内心烦恼"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "尽量看到事物好的一面"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "改变自己的想法，重新发现生活中什么重要"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "不把问题看得太严重"
                            }
                        },
                        {
                            "value": "Row 6",
                            "text": {
                                "zh-cn": "坚持自己的立场，为自己想得到的斗争"
                            }
                        },
                        {
                            "value": "Row 7",
                            "text": {
                                "zh-cn": "找出几种不同的解决问题的方法"
                            }
                        },
                        {
                            "value": "Row 8",
                            "text": {
                                "zh-cn": "向亲戚朋友或同学寻求建议"
                            }
                        },
                        {
                            "value": "Row 9",
                            "text": {
                                "zh-cn": "改变原来的一些做法或自己的一些问题"
                            }
                        },
                        {
                            "value": "Row 10",
                            "text": {
                                "zh-cn": "借鉴他人处理类似困难情景的办法"
                            }
                        },
                        {
                            "value": "Row 11",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法1",
                                "zh-cn": "寻求业余爱好，积极参加文体活动"
                            }
                        },
                        {
                            "value": "Row 12",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法2",
                                "zh-cn": "尽量克制自己的失望、悔恨、悲伤和愤怒"
                            }
                        },
                        {
                            "value": "Row 13",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法3",
                                "zh-cn": "试图休息或休假，暂时把问题（烦恼）抛开"
                            }
                        },
                        {
                            "value": "Row 14",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法4",
                                "zh-cn": "通过吸烟、喝酒、服药和吃东西来解除烦恼"
                            }
                        },
                        {
                            "value": "Row 15",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法5",
                                "zh-cn": "认为时间会改变现状，唯一要做的便是等待"
                            }
                        },
                        {
                            "value": "Row 16",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法6",
                                "zh-cn": "试图忘记整个事情"
                            }
                        },
                        {
                            "value": "Row 17",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法7",
                                "zh-cn": "依靠别人（如父母等）解决问题"
                            }
                        },
                        {
                            "value": "Row 18",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法8",
                                "zh-cn": "接受现实，因为没有其它办法"
                            }
                        },
                        {
                            "value": "Row 19",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法9",
                                "zh-cn": "幻想可能会发生某种奇迹改变现状"
                            }
                        },
                        {
                            "value": "Row 20",
                            "text": {
                                "default": "借鉴他人处理类似困难情景的办法10",
                                "zh-cn": "自己安慰自己"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question15",
                    "title": {
                        "zh-cn": "请根据你过去半个月的状况，回答是否存在下列描述的状况及其发生频率；请选出最符合的选项。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "完全不会"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "少数几天"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "一半以上的天数"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "几乎每天"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "在过去的半月里，感觉紧张，焦虑或急切"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "在过去的半月里，不能够停止或控制担忧"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "在过去的半月里，对各种各样的事情担忧过多"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "在过去的半月里，很难放松下来"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "在过去的半月里，由于不安而无法静坐"
                            }
                        },
                        {
                            "value": "Row 6",
                            "text": {
                                "zh-cn": "在过去的半月里，变得容易烦恼或急躁"
                            }
                        },
                        {
                            "value": "Row 7",
                            "text": {
                                "zh-cn": "在过去的半月里，感到似乎将有可怕的事情发生而害怕"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question16",
                    "title": {
                        "zh-cn": "请根据你和你家人的实际情况，回答以下问题。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "从不"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "偶尔"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "有时"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "经常"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "总是"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "当我遇到问题时，可以向家人得到满意的帮助。"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "我很满意家人与我讨论各种事情以及分担问题的方式。"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "当我希望从事新的活动或发展时，家人都能接受且给予支持。"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "我很满意家人对我表达情感的方式以及对我情绪的反应。"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "我很满意家人与我共度时光的方式。"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question17",
                    "title": {
                        "zh-cn": "以下事件在你的生活中发生过吗？对你的影响如何？请根据实际情况在每道题后做出选择。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "未发生"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "发生了，没有影响"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "发生了，影响较小"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "发生了，影响较大"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "发生了，影响很大"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "跟父母发生冲突，遭父母责骂。"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "父母之间发生很大冲突。"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "被老师当众批评。"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "考试失败或考得不理想。"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "父母对我的期待太高。"
                            }
                        },
                        {
                            "value": "Row 6",
                            "text": {
                                "zh-cn": "家庭经济困难。"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question20",
                    "title": {
                        "zh-cn": "请根据你在所就读学校里的日常感受，就学生关系选择最符合自己看法的选项。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "非常不同意"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "不同意"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "不确定"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "同意"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "非常同意"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "学生们彼此友好相待。"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "学生之间互相关心。"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "不同背景的学生之间相互尊重。"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "学生之间相互尊重。"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "学生之间相处融洽。"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question18",
                    "title": {
                        "zh-cn": "请根据你在所就读学校里的日常感受，就师生关系选择最符合自己看法的选项。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "非常不同意"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "不同意"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "不确定"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "同意"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "非常同意"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "老师对不同背景的同学给予同样的尊重。"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "老师们关心他们的学生。"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "当学生有困难的时候，老师倾听他们的心声。"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "在学校工作的大人们关心学生。"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "老师喜欢他们的学生。"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question19",
                    "title": {
                        "zh-cn": "请根据你在所就读学校里的日常感受，就校园欺负选择最符合自己看法的选项。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "非常不同意"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "不同意"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "不确定"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "同意"
                            }
                        },
                        {
                            "value": "Column 5",
                            "text": {
                                "zh-cn": "非常同意"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "有学生威胁和欺负其他学生。"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "欺负行为在这所学校是个大问题。"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "学生相互欺负。"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "学生们担心其他人欺负他们。"
                            }
                        }
                    ]
                }
            ],
            "title": {
                "zh-cn": "第1页/共3页"
            }
        },
        {
            "name": "page2",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "question21",
                    "title": {
                        "zh-cn": "你近期有没有因为成绩有较大退步、或者考试失利、或者学习效率低下等，觉得学习压力增大而难以承受？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "基本没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有一点"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，比较严重"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question22",
                    "title": {
                        "zh-cn": "你近期有没有与父母发生冲突？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "基本没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有一点冲突，但不严重"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，很严重"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question23",
                    "title": {
                        "zh-cn": "你近期有没有因与异性朋友分手、或向异性表白被拒而受到打击？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，打击不大"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，打击严重"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question24",
                    "title": {
                        "zh-cn": "你近期有没有与老师或同学发生冲突而关系紧张？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有时会有冲突，但不严重"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有严重冲突，关系很紧张"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question25",
                    "title": {
                        "zh-cn": "你最近有没有遭到他人欺辱？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "基本没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有一点，但不严重"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，很严重"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question26",
                    "title": {
                        "zh-cn": "你家里近期有没有出现经济困难问题？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有一点，但不严重"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，很严重"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question27",
                    "title": {
                        "zh-cn": "你近期有没有因关系密切的亲友死亡或重病重伤而受到打击？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，但受到的打击不严重"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，受到打击很严重"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question28",
                    "title": {
                        "zh-cn": "你近期有没有患上重大疾病或受重伤？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "近期身体欠佳，但不严重"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "近期患上严重疾病"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question29",
                    "title": {
                        "zh-cn": "你近期有没有对以往感兴趣的娱乐活动突然丧失兴趣？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "似乎有一点"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，表现得非常明显"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question30",
                    "title": {
                        "zh-cn": "你近期有没有表现出冲动失控的言行（如变得烦躁不安易发脾气、漫无目的地四处游荡等）？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "似乎有一点"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，表现得非常明显"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question31",
                    "title": {
                        "zh-cn": "你近期有没有故意伤害自己的身体？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "似乎有一点"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，表现得非常明显"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question32",
                    "title": {
                        "zh-cn": "你近期是否有睡眠困难（如入睡困难、多梦、早醒且醒后无法入睡）？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有一点"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，表现得非常明显"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question33",
                    "title": {
                        "zh-cn": "你近期有没有表达过自杀的想法或计划？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，偶尔一两次"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，经常会表达"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question34",
                    "title": {
                        "zh-cn": "你近期有没有无故与亲朋好友告别？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，偶尔一两次"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，最近多次发生"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question35",
                    "title": {
                        "zh-cn": "你近期是否会认为自己一无是处、没有存在的价值？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "不会"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有时会这么认为"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "经常会这么认为"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question36",
                    "title": {
                        "zh-cn": "你近期是否会觉得自己的问题无法解决、无人帮助？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有这种感觉"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有时会有这种感觉"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，最近常常有这种感觉"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question37",
                    "title": {
                        "zh-cn": "你近期有没有突然无故旷课？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，偶尔一两次"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，最近多次发生"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question38",
                    "title": {
                        "zh-cn": "你近期是否会觉得自己反应迟钝，难以和他人有效交流？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "没有这种感觉"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有时会有这种感觉"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "有，最近常常有这种感觉"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question39",
                    "title": {
                        "zh-cn": "你感到有人关心爱护你吗？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "经常感到"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "偶然感到"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "从来没感到"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question40",
                    "title": {
                        "zh-cn": "你感到有人能够帮助你吗？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "经常感到"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "偶然感到"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "从来没感到"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question41",
                    "title": {
                        "zh-cn": "一旦你在这个世界上消失，你觉得自己有没有难以放下的人或事？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "有，很强烈"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，但是不强烈"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "从来没有"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question42",
                    "title": {
                        "zh-cn": "你觉得在这个世界上有没有值得自己留恋的东西？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "有，我真的非常留恋"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，但是我可以放得下"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "基本没有"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question43",
                    "title": {
                        "zh-cn": "如果你感到痛苦的话，会不会认为这种痛苦将永远无法摆脱？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "完全不会"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "可能会"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "一定会"
                            }
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "question44",
                    "title": {
                        "zh-cn": "你觉得自己的未来有希望吗？"
                    },
                    "choices": [
                        {
                            "value": "Item 1",
                            "text": {
                                "zh-cn": "有，我坚信"
                            }
                        },
                        {
                            "value": "Item 2",
                            "text": {
                                "zh-cn": "有，但是我不确定"
                            }
                        },
                        {
                            "value": "Item 3",
                            "text": {
                                "zh-cn": "基本没有"
                            }
                        }
                    ]
                }
            ],
            "title": {
                "zh-cn": "第2页/共3页"
            }
        },
        {
            "name": "page3",
            "elements": [
                {
                    "type": "matrix",
                    "name": "question45",
                    "title": {
                        "zh-cn": "请根据你过去半个月的状况，回答是否存在下列描述的状况及其发生频率；请选出最符合的选项。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "完全不会"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "少数几天"
                            }
                        },
                        {
                            "value": "Column 3",
                            "text": {
                                "zh-cn": "一半以上的天数"
                            }
                        },
                        {
                            "value": "Column 4",
                            "text": {
                                "zh-cn": "几乎每天"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "在过去的半月里，做事时提不起劲或没有兴趣"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "在过去的半月里，感到心情低落、沮丧或绝望"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "在过去的半月里，入睡困难、睡不安稳或睡眠过多"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "在过去的半月里，感觉疲倦或没有活力"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "在过去的半月里，食欲不振或吃太多"
                            }
                        },
                        {
                            "value": "Row 6",
                            "text": {
                                "zh-cn": "在过去的半月里，觉得自己很糟，或觉得自己很失败，或觉得让自己或家人失望"
                            }
                        },
                        {
                            "value": "Row 7",
                            "text": {
                                "zh-cn": "在过去的半月里，对事物专注有困难，例如阅读报纸或看电视时"
                            }
                        },
                        {
                            "value": "Row 8",
                            "text": {
                                "zh-cn": "在过去的半月里，动作或说话速度缓慢到别人已经觉察或烦躁、坐立不安、动来动去的情况更胜于平常"
                            }
                        },
                        {
                            "value": "Row 9",
                            "text": {
                                "zh-cn": "在过去的半月里，有不如死掉或用某种方式伤害自己的念头（2-1-1-2测查点：自杀意念）"
                            }
                        }
                    ]
                },
                {
                    "type": "matrix",
                    "name": "question46",
                    "title": {
                        "zh-cn": "这些测题是调查你的心情和感受的,不是测验智力和学习能力,与学习成绩无关,答案也没有好坏之分,请按照你平时所想的如实选择“是”或“否”，回答时间没有限制，但不要过分考虑，请写出你最初想到的答案。"
                    },
                    "columns": [
                        {
                            "value": "Column 1",
                            "text": {
                                "zh-cn": "是"
                            }
                        },
                        {
                            "value": "Column 2",
                            "text": {
                                "zh-cn": "否"
                            }
                        }
                    ],
                    "rows": [
                        {
                            "value": "Row 1",
                            "text": {
                                "zh-cn": "你是否讨厌他人在背后对你议论？"
                            }
                        },
                        {
                            "value": "Row 2",
                            "text": {
                                "zh-cn": "你在当众被老师提问时，是否会脸红？"
                            }
                        },
                        {
                            "value": "Row 3",
                            "text": {
                                "zh-cn": "你是否很担心被任命为班干部？"
                            }
                        },
                        {
                            "value": "Row 4",
                            "text": {
                                "zh-cn": "你受到批评时，是否会心情不愉快？"
                            }
                        },
                        {
                            "value": "Row 5",
                            "text": {
                                "zh-cn": "你受到老师批评时，是否总是感到不安？"
                            }
                        },
                        {
                            "value": "Row 6",
                            "text": {
                                "zh-cn": "你是否经常觉得有同学在背后说你的坏话？"
                            }
                        },
                        {
                            "value": "Row 7",
                            "text": {
                                "zh-cn": "你是否总是觉得好像有人在注意你？"
                            }
                        },
                        {
                            "value": "Row 8",
                            "text": {
                                "zh-cn": "在学习时如果有人注意你，你心里是否紧张？"
                            }
                        },
                        {
                            "value": "Row 9",
                            "text": {
                                "zh-cn": "你受到父母批评后，是否总是耿耿于怀？"
                            }
                        },
                        {
                            "value": "Row 10",
                            "text": {
                                "zh-cn": "你在游戏或与竞争中输给了对方，是否就想要立刻放弃？"
                            }
                        },
                        {
                            "value": "Row 11",
                            "text": {
                                "zh-cn": "你是否认为考试成绩表现出的分数总是不大可靠的？"
                            }
                        },
                        {
                            "value": "Row 12",
                            "text": {
                                "zh-cn": "你是否希望考试能顺利通过？"
                            }
                        },
                        {
                            "value": "Row 13",
                            "text": {
                                "zh-cn": "考试成绩不理想时，你心里是否感到不快？"
                            }
                        },
                        {
                            "value": "Row 14",
                            "text": {
                                "zh-cn": "考试时想不起原本掌握的知识时，你是否会感到焦虑？"
                            }
                        },
                        {
                            "value": "Row 15",
                            "text": {
                                "zh-cn": "考试后，在成绩未知之前，你是否总是放心不下？"
                            }
                        },
                        {
                            "value": "Row 16",
                            "text": {
                                "zh-cn": "你是否做过考试考砸了的梦？"
                            }
                        },
                        {
                            "value": "Row 17",
                            "text": {
                                "zh-cn": "你是否做过成绩不好受到父母老师训斥的梦？"
                            }
                        },
                        {
                            "value": "Row 18",
                            "text": {
                                "zh-cn": "当众朗读课文时，你是否总是怕读错？"
                            }
                        },
                        {
                            "value": "Row 19",
                            "text": {
                                "zh-cn": "睡觉时，你是否总想着明天的功课？"
                            }
                        },
                        {
                            "value": "Row 20",
                            "text": {
                                "zh-cn": "老师在向全班提问时，你是否会觉得是在提问自己而感到不安？"
                            }
                        },
                        {
                            "value": "Row 21",
                            "text": {
                                "zh-cn": "在没有完成学习任务之前，你是否会总担心完不成？"
                            }
                        },
                        {
                            "value": "Row 22",
                            "text": {
                                "zh-cn": "你是否认为你比别人更在意担忧学习？"
                            }
                        },
                        {
                            "value": "Row 23",
                            "text": {
                                "zh-cn": "学习成绩不好时，你是否总是提心吊胆？"
                            }
                        },
                        {
                            "value": "Row 24",
                            "text": {
                                "zh-cn": "你是否一听说“要考试”就紧张害怕？"
                            }
                        },
                        {
                            "value": "Row 25",
                            "text": {
                                "zh-cn": "你是否一遇到考试，就担心会考坏？"
                            }
                        },
                        {
                            "value": "Row 26",
                            "text": {
                                "zh-cn": "你是否认为自己难以应付令人为难的情形？"
                            }
                        },
                        {
                            "value": "Row 27",
                            "text": {
                                "zh-cn": "你是否有时会后悔“那件事不做就好了”？"
                            }
                        },
                        {
                            "value": "Row 28",
                            "text": {
                                "zh-cn": "你和同学吵架以后，是否总是认为过错在自己？"
                            }
                        },
                        {
                            "value": "Row 29",
                            "text": {
                                "zh-cn": "你在体育比赛输了时，心里是否还一直埋怨自己不好？"
                            }
                        },
                        {
                            "value": "Row 30",
                            "text": {
                                "zh-cn": "集体受到责备时，你是否认为主要是自己的过错？"
                            }
                        },
                        {
                            "value": "Row 31",
                            "text": {
                                "zh-cn": "你是否总认为是自己不用功才会学习成绩不理想？"
                            }
                        },
                        {
                            "value": "Row 32",
                            "text": {
                                "zh-cn": "你失败时，是否总认为是自己的责任？"
                            }
                        },
                        {
                            "value": "Row 33",
                            "text": {
                                "zh-cn": "你在体育比赛时，是否一出错就特别在意？"
                            }
                        },
                        {
                            "value": "Row 34",
                            "text": {
                                "zh-cn": "你受到批评后，是否总感到内疚？"
                            }
                        },
                        {
                            "value": "Row 35",
                            "text": {
                                "zh-cn": "别人笑你时，你是否会认为是自己做错了什么？"
                            }
                        },
                        {
                            "value": "Row 36",
                            "text": {
                                "zh-cn": "你的朋友是否很少？"
                            }
                        },
                        {
                            "value": "Row 37",
                            "text": {
                                "zh-cn": "你是否不喜欢同别人交谈？"
                            }
                        },
                        {
                            "value": "Row 38",
                            "text": {
                                "zh-cn": "你和大家在一起时，是否也觉得自己很孤单？"
                            }
                        },
                        {
                            "value": "Row 39",
                            "text": {
                                "zh-cn": "在人多的地方，你是否觉得很怕？"
                            }
                        },
                        {
                            "value": "Row 40",
                            "text": {
                                "zh-cn": "你是否不大会在同学们在笑时也一起跟着开怀？"
                            }
                        },
                        {
                            "value": "Row 41",
                            "text": {
                                "zh-cn": "相比和同学一起玩，你是否更喜欢自己一个人玩？"
                            }
                        },
                        {
                            "value": "Row 42",
                            "text": {
                                "zh-cn": "同学们在交谈时，你是否不想加入？"
                            }
                        },
                        {
                            "value": "Row 43",
                            "text": {
                                "zh-cn": "和大家在一起时，你是否觉得自己多余？"
                            }
                        },
                        {
                            "value": "Row 44",
                            "text": {
                                "zh-cn": "你是否讨厌参加运动会等集体活动？"
                            }
                        },
                        {
                            "value": "Row 45",
                            "text": {
                                "zh-cn": "你是否觉得到同学家里去玩不如在自己家里玩？"
                            }
                        },
                        {
                            "value": "Row 46",
                            "text": {
                                "zh-cn": "你是否经常做噩梦？"
                            }
                        },
                        {
                            "value": "Row 47",
                            "text": {
                                "zh-cn": "你是否喜欢整夜开着灯睡觉？"
                            }
                        },
                        {
                            "value": "Row 48",
                            "text": {
                                "zh-cn": "你是否非常害怕听到打雷声？"
                            }
                        },
                        {
                            "value": "Row 49",
                            "text": {
                                "zh-cn": "你是否很怕高的地方？"
                            }
                        },
                        {
                            "value": "Row 50",
                            "text": {
                                "zh-cn": "你是否有很多害怕的东西？"
                            }
                        },
                        {
                            "value": "Row 51",
                            "text": {
                                "zh-cn": "你是否非常害怕黑暗？"
                            }
                        },
                        {
                            "value": "Row 52",
                            "text": {
                                "zh-cn": "你是否经常感到后面有人跟着？"
                            }
                        },
                        {
                            "value": "Row 53",
                            "text": {
                                "zh-cn": "你乘车穿过黑暗隧道或路过高架桥时，是否会感到害怕？"
                            }
                        },
                        {
                            "value": "Row 54",
                            "text": {
                                "zh-cn": "你胆子是否很小？"
                            }
                        },
                        {
                            "value": "Row 55",
                            "text": {
                                "zh-cn": "你是否很怕一个人在房间里睡觉？"
                            }
                        },
                        {
                            "value": "Row 56",
                            "text": {
                                "zh-cn": "你手上是否经常出汗？"
                            }
                        },
                        {
                            "value": "Row 57",
                            "text": {
                                "zh-cn": "你害羞时是否会脸涨红吗？"
                            }
                        },
                        {
                            "value": "Row 58",
                            "text": {
                                "zh-cn": "你是否经常认为自己的身材和长相比别人难看？"
                            }
                        },
                        {
                            "value": "Row 59",
                            "text": {
                                "zh-cn": "你是否经常觉得肠胃不好？"
                            }
                        },
                        {
                            "value": "Row 60",
                            "text": {
                                "zh-cn": "是否经常感到头痛？"
                            }
                        },
                        {
                            "value": "Row 61",
                            "text": {
                                "zh-cn": "你被老师提问时，心里是否总是很紧张？"
                            }
                        },
                        {
                            "value": "Row 62",
                            "text": {
                                "zh-cn": "你是否经常咬指甲？"
                            }
                        },
                        {
                            "value": "Row 63",
                            "text": {
                                "zh-cn": "你是否舔手指？"
                            }
                        },
                        {
                            "value": "Row 64",
                            "text": {
                                "zh-cn": "夜里你是否很难入睡？"
                            }
                        },
                        {
                            "value": "Row 65",
                            "text": {
                                "zh-cn": "你是否总觉得身体好像有什么毛病？"
                            }
                        },
                        {
                            "value": "Row 66",
                            "text": {
                                "zh-cn": "你是否经常感到呼吸困难？"
                            }
                        },
                        {
                            "value": "Row 67",
                            "text": {
                                "zh-cn": "即使没有剧烈运动，你的心脏是否经常跳得厉害？"
                            }
                        },
                        {
                            "value": "Row 68",
                            "text": {
                                "zh-cn": "你是否很容易疲倦？"
                            }
                        },
                        {
                            "value": "Row 69",
                            "text": {
                                "zh-cn": "你是否很不愿吃药？"
                            }
                        },
                        {
                            "value": "Row 70",
                            "text": {
                                "zh-cn": "你去厕所的次数是否比别人多？"
                            }
                        },
                        {
                            "value": "Row 71",
                            "text": {
                                "zh-cn": "碰到不顺利的事情时，你是否会感到心里很烦躁？"
                            }
                        },
                        {
                            "value": "Row 72",
                            "text": {
                                "zh-cn": "你是否非常担心家里有人生病或去世？"
                            }
                        },
                        {
                            "value": "Row 73",
                            "text": {
                                "zh-cn": "你心里是否总想为班级做点好事？"
                            }
                        },
                        {
                            "value": "Row 74",
                            "text": {
                                "zh-cn": "你学习时，是否经常开小差？"
                            }
                        },
                        {
                            "value": "Row 75",
                            "text": {
                                "zh-cn": "你心里是否总觉得好像有什么事没有做好？"
                            }
                        },
                        {
                            "value": "Row 76",
                            "text": {
                                "zh-cn": "你是否担心会发生意外？"
                            }
                        },
                        {
                            "value": "Row 77",
                            "text": {
                                "zh-cn": "你是否在梦里见到过去世的亲友？"
                            }
                        },
                        {
                            "value": "Row 78",
                            "text": {
                                "zh-cn": "你对电视机和汽车的声音是否特别敏感？"
                            }
                        },
                        {
                            "value": "Row 79",
                            "text": {
                                "zh-cn": "你是否总是在做决定时犹豫不决？"
                            }
                        },
                        {
                            "value": "Row 80",
                            "text": {
                                "zh-cn": "你把东西借给别人时，是否担心别人会把东西弄坏？"
                            }
                        },
                        {
                            "value": "Row 81",
                            "text": {
                                "zh-cn": "你是否经常生气？"
                            }
                        },
                        {
                            "value": "Row 82",
                            "text": {
                                "zh-cn": "你是否不想得到好的成绩？"
                            }
                        },
                        {
                            "value": "Row 83",
                            "text": {
                                "zh-cn": "你是否会经常急躁得坐立不安？"
                            }
                        },
                        {
                            "value": "Row 84",
                            "text": {
                                "zh-cn": "你以前是否说过谎话？"
                            }
                        },
                        {
                            "value": "Row 85",
                            "text": {
                                "zh-cn": "你有时是否想过自己一个人离家出走？"
                            }
                        },
                        {
                            "value": "Row 86",
                            "text": {
                                "zh-cn": "你是否经常迟到？"
                            }
                        },
                        {
                            "value": "Row 87",
                            "text": {
                                "zh-cn": "你是否经常想大声喊叫？"
                            }
                        },
                        {
                            "value": "Row 88",
                            "text": {
                                "zh-cn": "你是否不能守口如瓶？"
                            }
                        },
                        {
                            "value": "Row 89",
                            "text": {
                                "zh-cn": "你有时是否会觉得，还是死了好？"
                            }
                        },
                        {
                            "value": "Row 90",
                            "text": {
                                "zh-cn": "你是否总是很没有礼貌？"
                            }
                        },
                        {
                            "value": "Row 91",
                            "text": {
                                "zh-cn": "你被人说了坏话，是否想立即报复？"
                            }
                        },
                        {
                            "value": "Row 92",
                            "text": {
                                "zh-cn": "老师或父母说的话，你是否常想反驳？"
                            }
                        },
                        {
                            "value": "Row 93",
                            "text": {
                                "zh-cn": "你心里不开心，是否会乱丢、乱砸东西？"
                            }
                        },
                        {
                            "value": "Row 94",
                            "text": {
                                "zh-cn": "你是否发过怒？"
                            }
                        },
                        {
                            "value": "Row 95",
                            "text": {
                                "zh-cn": "你想要的东西，是否就一定要拿到手？"
                            }
                        },
                        {
                            "value": "Row 96",
                            "text": {
                                "zh-cn": "你不喜欢的课，老师提前下课，你是否会感到特别高兴？"
                            }
                        },
                        {
                            "value": "Row 97",
                            "text": {
                                "zh-cn": "你是否经常想从高的地方跳下来？"
                            }
                        },
                        {
                            "value": "Row 98",
                            "text": {
                                "zh-cn": "你是否无论对谁都很不耐烦？"
                            }
                        },
                        {
                            "value": "Row 99",
                            "text": {
                                "zh-cn": "你是否经常会突然想哭？"
                            }
                        },
                        {
                            "value": "Row 100",
                            "text": {
                                "zh-cn": "对不认识的人，你是否会都喜欢？"
                            }
                        }
                    ]
                }
            ],
            "title": {
                "zh-cn": "第3页/共3页"
            }
        }
    ]
}
